import angular from 'angular';
import URLS from 'Helpers/urls';
import UTILS from 'Helpers/util';

(function() {
    'use strict';

    angular.module('app').component('complaint', {
        template: require('./complaint-module.html'),
        controller: ComplaintModuleCtrl,
        controllerAs: 'vm'
    });

    ComplaintModuleCtrl.$inject = [
        '$scope',
        '$state',
        '$rootScope',
        '$stateParams',
        '$location',
        'ModalService',
        'QueryService',
        'SessionService',
        'logger'
    ];

    function ComplaintModuleCtrl(
        $scope,
        $state,
        $rootScope,
        $stateParams,
        $location,
        ModalService,
        QueryService,
        SessionService,
        logger
    ) {

        var vm = this;
        vm.otherBackground = require('Images/project_dino_a_1024.png');
        vm.logo = require('Images/nav-logo.png');
        vm.isPassword = false;
        vm.submitted = false;

        vm.mode = $stateParams.mode;
        vm.id = $stateParams.id;

        vm.get_session = () => {

            var request = {
                method: 'GET',
                route: URLS.base + `/regular_class_item/${ vm.id }/regular_class`,
            };
            QueryService.query(request)
                .then(
                    function(response) {
                        vm.session = response.data.data.data[0];
                        console.log(vm.data);
                    },
                    function(error) {
                        logger.errorFormatResponse(error);
                    }
                )
                .finally(function() {
                    vm.loading = false;
                });

        };
        vm.get_session();

        vm.get_data = function(){

            var request = {
                method: 'GET',
                route: URLS.base + `/lookup-complaint`,
            };
            QueryService.query(request)
                .then(
                    function(response) {
                        console.log(response);
                        vm.complaints = response.data.data.items;
                    },
                    function(error) {
                        logger.errorFormatResponse(error);
                    }
                )
                .finally(function() {
                    vm.loading = false;
                });

        }


        vm.save = function(){

            if(vm.mode === 'receipt'){
                vm.resolution_type = 'Ask For Receipt';
            }
            const body = {
                type: vm.mode,
                session_id: $stateParams.id,
                complaint_id: vm.complaint_id,
                complaint_text: vm.complaint_text,
                resolution_type: vm.resolution_type,
                bank_number: vm.bank_number,
                bank_name: vm.bank_name,
                name: vm.name,
                student_name: vm.student_name,
                student_phone: vm.student_phone,
                student_kakao: vm.student_kakao,
                student_email: vm.student_email,
                amount: vm.amount,
                teacher_name: vm.teacher_name
            }

            var request = {
                method: 'POST',
                body,
                route: URLS.base + `/complaint`,
            };

            QueryService.query(request)
                .then(
                    function(response) {
                        vm.submitted = true;
                    },
                    function(error) {
                        logger.errorFormatResponse(error);
                    }
                )
                .finally(function() {
                    vm.loading = false;
                });
        }

        vm.goHomeYoureDrunk = () => {
            $location.path('home-page');
        };

        vm.get_data();
    }
})();



// WEBPACK FOOTER //
// ./src/app/components/complaints/complaint-module.component.js